/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {useState, useEffect} from "react";
import {createRoot} from "react-dom/client";
import {config} from "./config";
import AppHome from "@components/page/AppHome";
import Loading from "@components/Loading";
import {loginValidate} from "@util/LoginValidate";
import ErrorMessage from "@components/ErrorMessage";
import {t} from "@util/i18n";

if (config.env === 'local')
    new EventSource('/esbuild').addEventListener('change', () => location.reload())

const app = document.getElementById('app') as HTMLElement;
const root = createRoot(app);


const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

    useEffect(() => {
        const login = async () => {
            try {
                const result = await loginValidate();
                setIsLoggedIn(result);
            } catch (error) {
                console.error("Error in validation:", error);
                setIsLoggedIn(false);
            }
        };
        login().catch(console.error);
    }, [])

    return (
        <>
            {isLoggedIn === true && <AppHome/>}
            {isLoggedIn === false &&
                <ErrorMessage titleText={t("linkExpiredTitle")} errorText={t("linkExpiredText")}/>}
            {isLoggedIn === null &&
                <div className="bgDiv sentScreenContainer">
                    <Loading text={t("loggingIn")}/>
                </div>}
        </>
    )
}
root.render(<App/>);
